module.exports = exports = require('./lib');



//////////////////
// WEBPACK FOOTER
// ./~/mpath/index.js
// module id = 428
// module chunks = 0